import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'successful',
  templateUrl: 'successful.snackbar.html',
  styleUrls: ['successful.snackbar.scss'],
  standalone: false,
})
export class SuccessfulSnackBar {
  constructor(
    public snackBarRef: MatSnackBarRef<SuccessfulSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  public closeSnackBar(): void {
    this.snackBarRef.dismiss();
  }
}
